import { render } from "./FormDetail.vue?vue&type=template&id=5b327883&ts=true"
import script from "./FormDetail.vue?vue&type=script&lang=ts"
export * from "./FormDetail.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Waddecar Media\\Development\\Forms\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__